module.exports = __webpack_public_path__ + "img/jiejing3.6c663d10.png";